import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { formatDate } from '@roc/feature-utils';
import { formatCurrency } from '@roc/ui/utils';

const useStyles = makeStyles((theme: Theme) => ({
  headerCell: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    fontWeight: 600,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

const CURRENCY_FIELDS = new Set(['monthlyRent']);
const DATE_FIELDS = new Set(['date']);

const FIELD_LABELS: Record<string, string> = {
  tenantName: 'Tenant Name',
  date: 'Date',
  monthlyRent: 'Monthly Rent',
};

const FIELD_KEYS = Object.keys(FIELD_LABELS);

export interface TableProps {
  data: Record<string, any>;
}

export const ProofOfReceiptReviewTable = ({ data }: TableProps) => {
  const classes = useStyles();
  const receipts: Record<string, any>[] = Array.isArray(data?.receipts) ? data.receipts : [];

  const formatValue = (key: string, value: any) => {
    if (CURRENCY_FIELDS.has(key)) return value ? formatCurrency(Number(value)) : null;
    if (DATE_FIELDS.has(key)) return value ? formatDate(value, 'MMMM d, yyyy') : null;
    return String(value ?? '');
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          {FIELD_KEYS.map(key => (
            <TableCell key={key} className={classes.headerCell}>
              {FIELD_LABELS[key]}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {receipts.map((receipt, index) => (
          <TableRow key={index} className={index === receipts.length - 1 ? classes.lastRow : ''}>
            {FIELD_KEYS.map(key => (
              <TableCell key={key} className={classes.valueCell}>
                {formatValue(key, receipt?.[key])}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
